import ApiClient from '../ApiClient';

class AilabBulkActionsAPI extends ApiClient {
  constructor() {
    super('ailab/bulk_actions', { accountScoped: true });
  }
}

export default new AilabBulkActionsAPI();
